import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { reviewsClient } from '@integration/api-client/reviews';

const { actions, effects } = generateNgrxServiceClient(
  'Reviews',
  reviewsClient
);

export { actions as reviewActions, effects as reviewEffects };
